import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-familia-section relative py-10 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-250">
      <div className="absolute inset-0 bg-gradient-to-r from-familia-bg/60 to-familia-section opacity-60 pointer-events-none" data-id="element-251" />
      <div className="relative z-10 max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-252">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-6 md:mb-8 leading-tight" data-id="element-253">
          ¿Cuánto tiempo más el adulto mayor <br className="hidden md:block" data-id="element-254" />{' '}
          de tu familia va a quedar sin un sistema de cuidado real?
        </h2>
        <div className="space-y-2 text-familia-gray text-[15px] md:text-xl max-w-2xl mx-auto" data-id="element-255">
          <p data-id="element-256">El problema no es tu falta de amor ni de voluntad.</p>
          <p data-id="element-257">
            Es que hasta hoy no existía un material de bienestar senior diseñado
            para que TODA la familia pueda participar del cuidado con nivel
            profesional.
          </p>
          <p className="text-white font-bold" data-id="element-258">Pero eso cambió.</p>
          <p className="text-familia-cyan font-bold" data-id="element-259">Y está disponible hoy.</p>
        </div>
      </div>
    </section>;
};